/**
 * The rows a dragged row sits between after it is dropped on another row's position,
 * or null when the drop moves nothing.
 */
export const getReorderNeighbors = (
  ids: string[],
  sourceId: string,
  targetId: string
): { previousId: string | null; nextId: string | null } | null => {
  const sourceIndex = ids.indexOf(sourceId);
  const targetIndex = ids.indexOf(targetId);
  if (sourceIndex < 0 || targetIndex < 0 || sourceIndex === targetIndex) return null;
  const reordered = [...ids];
  reordered.splice(sourceIndex, 1);
  reordered.splice(targetIndex, 0, sourceId);
  return { previousId: reordered[targetIndex - 1] ?? null, nextId: reordered[targetIndex + 1] ?? null };
};
